/* UploadImageDropComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./UploadImageDropRenderer");

class UploadImageDropComponent extends EventEmitter {
    constructor(logger, message) {
        super();
        this._logger = logger;
        this._titleText = message || "Upload File";
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._context = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "CreateQuestionComponent.shutdown() error");
            }
        );
    }

    importFile(files) {
        this._context.resolve(files);
    }

    cancelAction() {
        this._context.reject();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = UploadImageDropComponent;
